import { LocalStorage } from '../utils/LocalStorage';

export const useGetToken = () => {
  const token = LocalStorage.getItem('jwt') as number;

  return { token };
};
